import {  secondaryColor } from "utils/dashboardUtils";

export const TimeAgoBadge = ({ date }) => {
  const { label, color } = getTimeAgoWithColor(date);

  return (
    <div className="d-flex align-items-center gap-2">
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: color,
          display: "inline-block",
        }}
      />
      <span style={{ fontSize: "12px",whiteSpace:"nowrap", color: secondaryColor }}>{label}</span>
    </div>
  );
};
function getTimeAgoWithColor(dateTime) {
  if (!dateTime) return { label: "", color: "#ccc" };

  const now = new Date();
  const past = new Date(dateTime);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60) {
    return { label: "Just now", color: "#22c55e" }; // green
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return {
      label: `${diffInMinutes} min${diffInMinutes > 1 ? "s" : ""} ago`,
      color: "#84cc16", // light green
    };
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return {
      label: `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`,
      color: "#f59e0b", // yellow/orange
    };
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return {
    label: `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
    color: "#9ca3af", // gray
  };
}
